var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfFileIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1495_4950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9998 7.95719V36C34.9998 38.2091 33.209 40 30.9998 40H9C6.79086 40 5 38.2091 5 36V4C5 1.79086 6.79086 0 9 0H26.3367L34.9998 7.95719Z",
    fill: "url(#paint0_linear_1495_4950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0745 26.9636C24.0764 26.9636 22.8274 27.1377 22.4187 27.1989C20.7274 25.4327 20.2462 24.4288 20.138 24.1611C20.2847 23.7843 20.795 22.3526 20.8676 20.5138C20.9033 19.5932 20.7089 18.9053 20.2894 18.4692C19.8707 18.0339 19.3638 18 19.2185 18C18.7089 18 17.8539 18.2577 17.8539 19.9834C17.8539 21.4808 18.5521 23.0696 18.745 23.4802C17.7283 26.4406 16.6367 28.4671 16.405 28.8839C12.3195 30.4221 12 31.9094 12 32.3309C12 33.0884 12.5395 33.5406 13.443 33.5406C15.6384 33.5406 17.6418 29.8549 17.9731 29.2149C19.5323 28.5936 21.6192 28.2088 22.1497 28.117C23.6715 29.5666 25.4314 29.9533 26.1623 29.9533C26.7122 29.9533 27.9999 29.9533 27.9999 28.6293C28 27.3998 26.4241 26.9636 25.0745 26.9636ZM24.9687 27.8328C26.1545 27.8328 26.4679 28.2249 26.4679 28.4323C26.4679 28.5624 26.4185 28.9869 25.7829 28.9869C25.213 28.9869 24.2289 28.6575 23.2607 27.9428C23.6645 27.8897 24.2619 27.8328 24.9687 27.8328ZM19.1562 18.8425C19.2644 18.8425 19.3355 18.8773 19.3942 18.9587C19.7353 19.4319 19.4603 20.9782 19.1256 22.1883C18.8025 21.1507 18.56 19.5587 18.9012 18.9986C18.9678 18.8892 19.0441 18.8425 19.1562 18.8425ZM18.5803 28.1046C19.0097 27.2373 19.4908 25.9733 19.7529 25.2584C20.2774 26.1363 20.9829 26.9514 21.3909 27.3933C20.1205 27.6611 19.1594 27.9287 18.5803 28.1046ZM12.8528 32.4467C12.8245 32.4131 12.8203 32.3424 12.8417 32.2575C12.8863 32.0796 13.2279 31.1977 15.6985 30.0925C15.3447 30.6498 14.7917 31.4459 14.1842 32.0407C13.7565 32.441 13.4235 32.644 13.1944 32.644C13.1124 32.644 12.9995 32.6217 12.8528 32.4467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1495_4950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9991 7.95719H27.3359C26.7837 7.95719 26.3359 7.50947 26.3359 6.95719V0L34.9991 7.95719Z",
    fill: "#E0EAFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1495_4950",
    x: 23.3359,
    y: -1,
    width: 12.6641,
    height: 11.957,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1495_4950"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1495_4950",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1495_4950",
    x1: 50.5,
    y1: -23.5,
    x2: -11.5,
    y2: 58.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686D75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90788,
    stopColor: "#00173D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1495_4950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfFileIcon);
export default __webpack_public_path__ + "static/media/pdfFileIcon.a8da89c8e97805bf40db46fdd920e564.svg";
export { ForwardRef as ReactComponent };